import { FormGroup } from '@angular/forms';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getCoopConsumoGroup = (form: FormGroup): FormGroup => getGroup(form, formPaths.schedaCoopConsumo);

export const getCoopConsumoControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.schedaCoopConsumo}.${path}`);
